"use client";

import Link from "next/link";

const quickLinks = [
  { name: "Início", href: "/" },
  { name: "Categorias", href: "/categorias" },
  { name: "Empresas", href: "/empresas" },
  { name: "Eventos", href: "/eventos" },
  { name: "Serviços", href: "/servicos" },
  { name: "Contato", href: "/contato" },
];

const socialLinks = [
  {
    name: "Facebook",
    icon: "fa-brands fa-facebook",
    url: "https://facebook.com",
  },
  {
    name: "LinkedIn",
    icon: "fa-brands fa-linkedin",
    url: "https://linkedin.com",
  },
  { name: "YouTube", icon: "fa-brands fa-youtube", url: "https://youtube.com" },
  { name: "TikTok", icon: "fa-brands fa-tiktok", url: "https://tiktok.com" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-mygreen text-gray-300 py-12">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <h3 className="text-white font-bold text-lg">Santa Fé Conecta</h3>
            <p className="text-sm leading-relaxed">
              Conectando você aos comércios e eventos de Santa Fé do Sul/SP.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-white font-semibold">Links Rápidos</h3>
            <ul className="space-y-2 text-sm">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    href={link.href}
                    className="hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="text-white font-semibold">Contato</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center space-x-2">
                <i
                  className="fa-solid fa-envelope text-[16px]"
                  aria-hidden="true"
                ></i>
                <a
                  href="mailto:contato@santafeconecta.com.br"
                  className="hover:text-white transition-colors"
                >
                  contato@santafeconecta.com.br
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <i
                  className="fa-solid fa-phone text-[16px]"
                  aria-hidden="true"
                ></i>
                <a
                  href="tel:+551799718095"
                  className="hover:text-white transition-colors"
                >
                  (17) 99719-8095
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i
                  className="fa-solid fa-location-dot text-[16px] mt-1"
                  aria-hidden="true"
                ></i>
                <span>
                  Santa Fé do Sul - SP <br />
                  Brasil
                </span>
              </li>
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="text-white font-semibold">Redes Sociais</h3>
            <p className="text-sm">Siga-nos e fique por dentro de tudo!</p>

            <ul className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <li key={social.name}>
                  <a
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full flex items-center justify-center bg-white/10 hover:bg-white/40 transition-colors"
                    aria-label={social.name}
                  >
                    <i
                      className={`${social.icon} text-xl text-white`}
                      aria-hidden="true"
                    ></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="my-8 h-px bg-white/20"></div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-white">
          <p>© {year} Santa Fé Conecta. Todos os direitos reservados.</p>
          <div className="flex items-center space-x-6">
            <Link
              href="/politica-privacidade"
              className="hover:text-gray-100 transition-colors"
            >
              Política de Privacidade
            </Link>
            <Link
              href="/termos-uso"
              className="hover:text-gray-100 transition-colors"
            >
              Termos de Uso
            </Link>
            <Link
              href="/exclusao-de-conta"
              className="hover:text-gray-100 transition-colors"
            >
              Excluir Conta
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
